import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";

export default function ConsultantPicker({ value, onChange }) {
  const [list, setList] = useState([]);
  const [addOpen, setAddOpen] = useState(false);
  const [nc, setNc] = useState({ name: "", phone: "", location: "" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/consultants").then(({ data }) => setList(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/consultants", nc);
      setAddOpen(false); setNc({ name: "", phone: "", location: "" });
      await load();
      onChange(data.id, data.name);
      toast.success("Consultant added");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <div className="flex gap-2">
      <Select value={value || "none"} onValueChange={(v) => {
        if (v === "none") onChange("", "");
        else { const c = list.find((x) => x.id === v); onChange(v, c?.name || ""); }
      }}>
        <SelectTrigger className="flex-1" data-testid="consultant-picker"><SelectValue placeholder="Not a consultant lead" /></SelectTrigger>
        <SelectContent className="bg-white">
          <SelectItem value="none">Not a consultant lead</SelectItem>
          {list.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button type="button" variant="outline" size="sm" onClick={() => setAddOpen(true)} data-testid="consultant-add-new"><Plus className="h-4 w-4" /> New</Button>

      <Dialog open={addOpen} onOpenChange={setAddOpen}>
        <DialogContent className="bg-white max-w-sm" data-testid="consultant-quick-add">
          <DialogHeader><DialogTitle>New consultant</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Name</Label><Input value={nc.name} onChange={(e) => setNc({ ...nc, name: e.target.value })} className="mt-1" data-testid="qc-name" /></div>
            <div><Label>Phone</Label><Input value={nc.phone} onChange={(e) => setNc({ ...nc, phone: e.target.value })} className="mt-1" data-testid="qc-phone" /></div>
            <div><Label>Location</Label><Input value={nc.location} onChange={(e) => setNc({ ...nc, location: e.target.value })} className="mt-1" data-testid="qc-location" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setAddOpen(false)}>Cancel</Button>
            <Button onClick={create} disabled={busy || !nc.name} data-testid="qc-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Add</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
